<template>
  <div class="row">
    <div v-if="document" class="col-xs-12 well" >

      <document-action :key="'' + document.documentID + '-'+ document.biblio" :document="document" :context="context"></document-action>
      <div class="clearfix"></div>
      <div class="row"  style="margin-top: 10px">
        <div class="col-md-2 col-xs-12 col-sm-3 item-label">
          <span>Title : </span>
        </div>
        <div class="col-md-10 col-xs-12 col-sm-9">
          <span v-html="document.title"></span>
        </div>
      </div>
      <div class="row" style="padding-top: 10px">
        <div class="col-md-2 col-xs-12 col-sm-3 item-label">
          <span>Authors : </span>
        </div>
        <div class="col-md-10 col-xs-12 col-sm-9">
          <template v-for="(coAuthor, key) in document.co_authors">
            <div class="row" :key="document.documentID+coAuthor.authorID + '-' + coAuthor.selected" style="margin-bottom: 5px">
              <div class="col-xs-3">{{coAuthor.lastName}} {{coAuthor.firstName}}</div>
              <div class="col-xs-6">
                <div class="col-xs-2 text-right" style="vertical-align: middle">
                  <flag v-if="coAuthor.affiliation && coAuthor.affiliation.organisationID" :squared="false" :iso="getIso(coAuthor.affiliation)" style="height: 100%"/>
                </div>
                <div class="col-md-10" v-if="coAuthor.affiliation && coAuthor.affiliation.organisationID" style="">{{coAuthor.affiliation.organisationName}}</div>
              </div>
              <div class="col-xs-3">
                <dropdown-author v-model="document.co_authors[key]" :context="context"></dropdown-author>
              </div>

            </div>

          </template>

        </div>
      </div>
      <div class="row" style="padding-top: 10px">
        <div class="col-md-2 col-xs-12 col-sm-3 item-label">
          <span>Source : </span>
        </div>
        <div class="col-md-10 col-xs-12 col-sm-9">
          <span> {{document.publication}}, {{ new Date(document.pubDate).getFullYear()}}</span>
        </div>
      </div>

      <div class="row" style="padding-top: 15px">
        <div class="col-md-2 col-xs-12 col-sm-3 item-label">
          <span>Abstract : </span>
        </div>
        <div class="col-md-10 col-xs-12 col-sm-9 " style="line-height: 1.8">
          <span v-html="document.abstract"></span>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
  .item-label {
    font-weight: bold;
  }
  .dropdown-author-action .btn-xs {
    padding: 1px 5px;
    font-size: 8px;
  }
  .selected {
    border-left: 5px solid #34495e;
  }
</style>
<script>
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'
import DropdownAuthor from './DropdownAuthor'
import DocumentAction from './DocumentAction'

IsoCountries.registerLocale(EnCountries)

export default {
  name: 'DocumentItem',
  components: {DocumentAction, DropdownAuthor},
  props: ['value', 'context'],
  watch: {
    value: function (val) {
      console.log('documentItem update document', val)
      this.document = val
    }
  },
  data () {
    return {
      document: null
    }
  },
  methods: {
    getIso: (affiliation) => {
      if (typeof affiliation !== 'undefined') {
        let iso = IsoCountries.getAlpha2Code(affiliation.country, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(affiliation.code)
        }
        return iso
      }
    }
  },
  beforeMount () {
    this.document = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentItem.vue